export default __webpack_public_path__ + "static/media/temp-blanket1.014f9098.png";